import { CdkPortalOutletAttachedRef, Portal } from '@angular/cdk/portal';
import { Component, ComponentRef } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { SidebarService } from '@m4u-angular/core/framework/sidebar.service';
import { EnumSidebarStates, EnumWindowSizes } from '@m4u-angular/core/framework/sysenums.enum';

class State extends BaseState {
    SidebarOpened: boolean;
}

export type SidebarPosition = 'left' | 'right';

@Component({
    providers: ServiceBagServices,
    selector: 'app-side-bar',
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent extends BaseComponent<State> {

    Name: string;
    Title: string;
    ContentPortal: Portal<any>;
    SidebarState: EnumSidebarStates;
    SidebarComponentOptions?: any;
    SidebarPinned: boolean;
    Width: EnumWindowSizes;
    Position: SidebarPosition;
    Class: string;

    get IsOpened() {
        return this.SidebarState === EnumSidebarStates.Opened;
    }

    get ShowPinButton() {
        return this.Name === 'Filters';
    }

    constructor(A: ServiceBagService, private sidebarService: SidebarService) {
        super(A, 'SideBarComponent', State);
    }

    ContentAttached(ref: CdkPortalOutletAttachedRef) {
        if (this.SidebarComponentOptions && ref instanceof ComponentRef) {
            Object.entries(this.SidebarComponentOptions).forEach(([key, value]) => {
                ref.instance[key] = value;
            });
        }
    }

    GetWidthClass() {
        const width = this.Width || EnumWindowSizes.WindowSmall;
        switch (width) {
            case EnumWindowSizes.WindowXSmall: return 'p-sidebar-xs';
            case EnumWindowSizes.WindowSmall: return 'p-sidebar-s';
            case EnumWindowSizes.WindowMedium: return 'p-sidebar-m';
            case EnumWindowSizes.WindowLarge: return 'p-sidebar-l';
            case EnumWindowSizes.WindowXLarge: return 'p-sidebar-xl';
            case EnumWindowSizes.WindowAutoSize: return 'auto';
        }
    }

    GetPositionClass() {
        return this.Position || (this.A.Screen.IsRTL() ? 'left' : 'right');
    }

    PinSidebar() {
        this.SidebarPinned = !this.SidebarPinned;
    }

    CloseSidebar() {
        this.sidebarService.Close(this.Name);
    }

    OnSidebarViewChanged(state: 'show' | 'hide') {
        const sidebarState = state === 'show' ? EnumSidebarStates.Opened : EnumSidebarStates.Closed;
        this.sidebarService.OnStateChanged(this.Name, sidebarState);
    }
}
